import React from 'react';

const ArrowRight = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M14.5 17L9.5 12L14.5 7" stroke="#8181A5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

export default ArrowRight;